
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/2021-bed-challenge",
      function () {
        return require("private-next-pages/archive/2021-bed-challenge.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/2021-bed-challenge"])
      });
    }
  